import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  FormModal,
  Input,
  Button,
  FormModalTitle,
  FormModalContent,
  FormModalActions,
  ConfirmModal,
  Typography,
} from 'sputnik-ui'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useDispatch } from 'react-redux'
import { addThirdPartyCamera } from 'features/Cameras/camerasSlice'
import { exportDevicesReport } from 'features/Devices/devicesSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import config from 'config'

import { Box, Link } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const validationSchema = yup.object().shape({
  email: yup.string().email().required(),
})

export default function ExportDeviceModal({
  open,
  handleClose,
  defaultEmail,
  ...props
}) {
  const dispatch = useDispatch()

  const formik = useFormik({
    validationSchema,
    initialValues: {
      email: defaultEmail,
    },
    onSubmit: (email) => {
      dispatch(exportDevicesReport(email))
        .then(unwrapResult)
        .then((el) => {
          handleClose()
        })
    },
  })

  const { t } = useTranslation(['common', 'device', 'info'])

  return (
    <>
      <FormModal open={open} {...props}>
        <form onSubmit={formik.handleSubmit}>
          <FormModalTitle>{t('devices:export.title')}</FormModalTitle>
          <FormModalContent label={t('devices:export.info')}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: 32,
              }}
            >
              <Link
                href={`${config.baseUri}/reports/example`}
                underline="always"
              >
                {t('devices:export.example')}
              </Link>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 10,
                  marginBottom: 24,
                  marginTop: 16,
                }}
              >
                <Box sx={{ display: 'inline-flex' }}>
                  <Typography color="textSecondary">
                    {t('devices:export.email_explain')}
                  </Typography>
                </Box>
                <Box sx={{ display: 'inline-flex' }}>
                  <Typography color="textSecondary">
                    {t('devices:export.limit_explain')}
                  </Typography>
                </Box>
                <Box sx={{ display: 'inline-flex' }}>
                  <Typography color="textSecondary">
                    {t('devices:export.email_warning')}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Input
              required
              name="email"
              value={formik.values.email}
              label={t('common:email')}
              onChange={formik.handleChange}
              error={formik.errors && formik.errors.email}
              fullWidth
            />
          </FormModalContent>
          <FormModalActions>
            <Button
              variant="v2"
              primary
              fullWidth
              type="submit"
              disabled={!(formik.values.email && !formik.errors.email)}
            >
              {t('devices:export.download')}
            </Button>
            <Button fullWidth variant="v2" tertiary onClick={handleClose}>
              {t('common:button.back')}
            </Button>
          </FormModalActions>
        </form>
      </FormModal>
    </>
  )
}
